export default __webpack_public_path__ + "static/media/virusyellow-250-5-min.711570b2.png";